import React from 'react'
import PropTypes from 'prop-types'

function HeaderStatisticsField({ number, text }) {
  return (
    <div className="col-12 col-sm-4 header-statistics__col">
      <div className="header-statistics__content">
        <p className="header-statistics__text">
          <span className="text-bold heading-32 info__number">
            {number}
          </span>
          <br />
          {text}
        </p>
      </div>
    </div>
  )
}

HeaderStatisticsField.propTypes = {
  number: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  text: PropTypes.string.isRequired,
}

export default HeaderStatisticsField
